import React, { ReactNode } from 'react';
import clsx from 'clsx';
import styles from './List.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  prepend?: ReactNode;
  divRef?: any;
}

export default function List({ divRef, prepend, children, ...props }: Props) {
  return (
    <div
      {...props}
      ref={divRef}
      className={clsx(styles.container, props.className)}
    >
      {prepend}
      {children}
    </div>
  );
}
